import React, { useEffect } from 'react'
import { resetOneSlice, selectOneState, changeConfirmationDialogState } from '../../../../../../features/oneMobile/oneSlice'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserInfo } from '../../../../../../features/userInfo/userInfoSlice'
import { selectBasicAccountState, setShouldBasicAccountPaymentRun, setTransactionIdToCancel } from '../../../../../../features/basicAccount/basicAccountSlice'
import { sendGeneralRequest } from '../../../../../../features/generalRequest'
import { runBasicAccountPayment } from '../../../../../general/BasicAccountMethods'
import { Grid , Button, Typography} from '@mui/material'
import colors from '../../../../../colors'
import ConfirmationDialog from '../../../../../general/ConfirmationDialog'
import { texts } from './../../../../../general/texts';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { selectUtilityState, setIsScaCompleted, setScaRequired } from '../../../../../../features/utilities/utilitySlice'

const OneSingleExpandedInvoice = (props) => 
    {
        const dispatch = useDispatch()
        const state = props.invoice
        const userInfo = useSelector(selectUserInfo)
        const basicAccountSliceState = useSelector(selectBasicAccountState)
        const utilitySliceState = useSelector(selectUtilityState)
        const oneSliceState = useSelector(selectOneState)
        const location = useLocation();
        const handleBackButton = () => 
        {
            dispatch(setShouldBasicAccountPaymentRun(false))
            dispatch(resetOneSlice())
        }
    
        const handleConfirmation = () => 
        {
            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, transID: oneSliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint: 'ASBS/ConfirmONEInvoices'}))
        }

        
    
        const handleButtonClick = () =>{
            let formattedPhone = oneSliceState?.singleInvoice?.Telefoni;
            if (oneSliceState?.singleInvoice?.Telefoni?.startsWith("355")) {
                formattedPhone = oneSliceState?.singleInvoice?.Telefoni.slice(3);
            }
            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, serial: oneSliceState.singleInvoice.Seriali, phone: formattedPhone }, baseUrlKey:'services', endpoint:'ASBS/StartONEInvoices'})).then(response => {
                if(response.payload.response.success){
                    if(userInfo.accountType === 3)
                        {   
                            dispatch(sendGeneralRequest({request: {token: props.globalDataSliceState.token, paymentMethod:'2', applicationID:1, value: oneSliceState.singleInvoice["Vlera"].replace(/[^.\d]/g,''), transID: oneSliceState.transactionId}, baseUrlKey:'services', endpoint:'startCreditCardPayment'}))
                            dispatch(setTransactionIdToCancel(oneSliceState.transactionId))
                        }
                        else
                        {
                            if (!response.payload.response.isScaRequired){
                            dispatch(changeConfirmationDialogState(true))
                            }
                        }
                }
            })
        }

            React.useEffect(()=> {
                    if (utilitySliceState.isScaRequired){
                        if (utilitySliceState.isScaCompleted){
                            dispatch(changeConfirmationDialogState())
                            dispatch(setScaRequired(false))
                            dispatch(setIsScaCompleted(false))
                        }
                    } 
            },[utilitySliceState.isScaRequired, utilitySliceState.isScaCompleted])

    
        useEffect(() => {
            const handleLocationChange = () => {
                dispatch(setShouldBasicAccountPaymentRun(false));
            };
        
            handleLocationChange(); // Initial call to handle location on mount
        
            return () => {
                handleLocationChange(); // Call on unmount
            };
        }, [location, dispatch]);
    
        return(
            <>      
                <Grid container justifyContent={'center'} p={3}> 
                    {
                    basicAccountSliceState.shouldBasicAccountPaymentRun 
                    ? 
                        runBasicAccountPayment(
                                dispatch,
                                basicAccountSliceState.basicAccountPaymentUrl,
                                {request: {token: props.globalDataSliceState.token, transID: oneSliceState.transactionId, service: props.utilityName, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'ASBS/ConfirmONEInvoices'},
                                {request: {token: props.globalDataSliceState.token, orderId: oneSliceState.transactionId}, baseUrlKey:'services', endpoint:'cancelCreditCardPayment'},
                                handleBackButton
                            ) 
                    :
                    <> 
                    <Grid container pb={'3%'}>
                        <Grid item md={10} xs={10} ></Grid>
                        <Grid item md={2} xs={2} pt={'1%'} ><Button onClick={handleBackButton} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                    </Grid>         
                        <Grid container md={12} pb={'10%'} item > 
                            {Object.entries(state).map(([key,value]) => {
                                return <Grid container item md={12} pb={'5%'} pr={'5%'}>
                                    <Grid container item justifyContent='flex-start' md={6}><Typography style={{color: colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1.9vh'}}>{key}</Typography></Grid>
                                    <Grid container item justifyContent='flex-end' md={6}><Typography style={{color: colors.gray, fontSize:'1.8vh', fontFamily:'GerberaLight'}}>{value}</Typography></Grid>
                                </Grid> 
                            })}                                                                                                                         
                        </Grid>
                        <Grid container item justifyContent={'center'} pb={'2%'} md={12}>
                            <Button disabled={oneSliceState.isLoading ? true : false} onClick={handleButtonClick} style={{background:colors.gradientOrange ,width:'100%', color:colors.white, fontFamily:'GerberaBold'}}>{texts["title-pay"]}</Button>        
                        </Grid>
                        </>   
                }                                                   
                </Grid>
                {oneSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={oneSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}      
            </>             
        )
}

export default OneSingleExpandedInvoice